import styled from 'styled-components';

export const Splitter = styled.div`
    height: 100px;
`;

export const ButtonContainer = styled.div`
    float: right;
`;